import { createApp } from 'vue';
import { createPinia } from 'pinia';
import maskDirective from './directives/mask';

import Contact from './pages/Contact.vue';
import Influencer from './pages/Influencer.vue';
import Dealer from './pages/Dealer.vue';
import Sac from './pages/Sac.vue';


let App = null;

if(document.querySelector('.page-vue-contact')) {
  App = Contact;
}
if(document.querySelector('.page-vue-dealer')) {
  App = Dealer;
}
if(document.querySelector('.page-vue-influencer')) {
  App = Influencer;
}
if(document.querySelector('.page-vue-sac')) {
  App = Sac;
}

if(App) {
  createApp(App)
  .use(createPinia())
  .directive('mask', maskDirective)
  .mount('#app');
}
